module.exports = __webpack_public_path__ + "KaTeX_Main-BoldItalic.d0631d89.woff2";